<script>
import { required } from "vuelidate/lib/validators";
import Modal from "@/components/modals/modal-form.vue";
import api from '@/helpers/apirest/api';

const initialState = () => {
    return {
        submitted: false,
        contract: {
            collaborator_id: null,
            contract_number: null,
            legacy_contract_number: null,
            signature_date: null,
            modification_date: null,
            observations: null,
            agreement_accepted: null,
        },
    };
}

export default {
    emits: ['onSuccess'],
    props: {
        modalId: String,
        id: Number,
        collaboratorId: Number
    },
    data() {
        return initialState();
    },
    components: {
        Modal,
    },
    computed: {
    },
    validations: {
        contract: {
            collaborator_id: { required },
            contract_number: { required },
            legacy_contract_number: { },
            signature_date: { },
            modification_date: { },
            observations: { },
            agreement_accepted: { },
        }
    },
    methods: {
        async shown() {
            this.$store.dispatch("identificationType/loadList");

            if (this.id) {
                const response = await api.get({
                    url: `collaborators/${this.collaboratorId}/contracts/${this.id}`,
                    config: {
                        withLoading: true
                    }  
                });

                const contract = response?.data?.data;
                this.contract = contract;
            }
        },
        async confirm() {

            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            }

            const data = this.contract;
            const response = await api.save({
                url: `collaborators/${this.collaboratorId}/contracts`,
                id: this.contract?.id,
                data: data,
                config: {
                    withLoading: true
                }
            });

            this.$bvModal.hide(this.modalId);
            this.$emit("onSuccess", response?.data?.data);
        },
        cancel() {
            this.$bvModal.hide(this.modalId);
        },
        resetModal() {
            Object.assign(this.$data, initialState());
        },
    }
};
</script>

<template>
    <Modal :title="'Formulario de contrato'" :id="modalId" @confirm="confirm" @cancel="cancel" @shown="shown" @hidden="resetModal" :size="'lg'">
        <div class="row">

            <div class="col-12">
                <div class="card h-100">
                    <div class="card-body">
                        <div class="row">
                            <div class="form-group col-12">
                                <label for="contract_number">Número de contrato</label>
                                <input id="contract_number" v-model="contract.contract_number" type="text" class="form-control" placeholder="Ingresa un número de contrato"
                                    :class="{ 'is-invalid': $v.contract.contract_number.$error && submitted }" />
                                <div v-if="!$v.contract.contract_number.required && submitted" class="invalid-feedback">Número de contrato es requerido</div>
                            </div>
                            <div class="form-group col-12">
                                <label for="legacy_contract_number">Número de contrato (legacy)</label>
                                <input id="legacy_contract_number" v-model="contract.legacy_contract_number" type="text" class="form-control" placeholder="Ingresa un Número de contrato legacy"
                                    :class="{ 'is-invalid': $v.contract.legacy_contract_number.$error && submitted }" />
                            </div>
                            <div class="form-group col-12">
                                <label for="signature_date">Fecha de firma</label>
                                <input id="signature_date" v-model="contract.signature_date" type="date" class="form-control" placeholder="Ingresa una fecha de firma"
                                    :class="{ 'is-invalid': $v.contract.signature_date.$error && submitted }" />
                            </div>
                            <div class="form-group col-12">
                                <label for="modification_date">Fecha de modificación</label>
                                <input id="modification_date" v-model="contract.modification_date" type="date" class="form-control" placeholder="Ingresa una fecha de modificación"
                                    :class="{ 'is-invalid': $v.contract.modification_date.$error && submitted }" />
                            </div>
                            <div class="form-group col-12">
                                <label for="observations">Observaciones</label>
                                <textarea id="observations" v-model="contract.observations" type="date" class="form-control" placeholder="Ingresa las observaciones"
                                    :class="{ 'is-invalid': $v.contract.observations.$error && submitted }"></textarea>
                            </div>
                            <div class="form-group col-12">
                                <label for="agreement_accepted">Aceptó terminos y condiciones</label>
                                <div class="custom-control custom-checkbox">
                                    <input
                                        type="checkbox"
                                        v-model="contract.agreement_accepted"
                                        class="custom-control-input"
                                        id="agreement_accepted"
                                    />
                                    <label class="custom-control-label" for="agreement_accepted">Sí</label>
                                </div>
                            </div>  
                            
                        </div>                         
                    </div>
                </div>
            </div>
        </div>
    </Modal>
</template>